<template>
  <ViewWrapper class="about" :scrollable="true" @close="$router.replace({ name: 'summary' })">
    <div class="about__inner">
      <h2>{{ $t('view.about.sectionMakeAShift.headline') }}</h2>
      <p>{{ $t('view.about.sectionMakeAShift.copy') }}</p>
      <ButtonPill
        class="about__button"
        :href="$t('view.about.sectionMakeAShift.buttonUrl')"
        target="_blank"
      >
        {{ $t('view.about.sectionMakeAShift.buttonLabel') }}
      </ButtonPill>

      <h2>{{ $t('view.about.sectionResponsibleBusiness.headline') }}</h2>
      <p>{{ $t('view.about.sectionResponsibleBusiness.copy') }}</p>

      <h2>{{ $t('view.about.sectionGoalsSustainableFuture.headline') }}</h2>
      <ButtonPill
        class="about__button"
        :href="$t('view.about.sectionGoalsSustainableFuture.buttonUrl')"
        target="_blank"
      >
        {{ $t('ui.moreInformation') }}
      </ButtonPill>
    </div>
  </ViewWrapper>
</template>
<script>
import ButtonPill from '../components/ButtonPill';
import ViewWrapper from '../components/ViewWrapper';

export default {
  name: 'About',
  components: {
    ButtonPill,
    ViewWrapper,
  },
};
</script>

<style lang="scss" scoped>
.about {
  background-color: rgba($color-black, $view-overlay-alpha-dark);
  @include helper__box-shadow_overlap($color-black);
}

.about__inner {
  max-width: 320px;
  margin-top: 80px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;

  p {
    line-height: 26px;
    margin-bottom: 40px;
  }
}

.about__headline {
  font-size: 35px;
  text-align: left;
  margin-bottom: 20px;
  font-weight: bold;
}

$item-padding: 10px;
.about__slide {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  line-height: 26px;
  @include transparent-layer($item-padding);
}

.about__goal_image {
  width: 33%;
}

.about__button {
  max-width: 200px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>
